//Helpers
import { convertCost } from 'src/helpers/units_helpers';
import { DEFAULT_CHART_HEIGHT } from '../../config/chart_config';
import { addDate, getNumberOfWeekDaysInMonth, startsWeekOnSun } from 'src/helpers/date_helper';
//Types
import type { ChartDataInterface } from 'src/types/Chart';
import type { MonthlyReport } from 'src/types/requests/charts/get_stats_period';

export const getMonthlyReport = (
	type: 'hour' | 'day' | 'week',
	dataSet: MonthlyReport,
	year: number,
	month: number,
	currency: string,
): ChartDataInterface => {
	const startDate = Date.UTC(type == 'week' ? 2023 : year, type == 'week' ? 0 : month, 1, 0, 0, 0, 0),
		consumptionData = [],
		periods = {
			hour: 24,
			week: 7,
			day: new Date(year, month + 1, 0).getDate(),
		},
		days = getNumberOfWeekDaysInMonth(month, year);
	let maxValue = 0,
		mostConsumingData = null;
	for (let i = 0; i < periods[type]; ++i) {
		let dt = addDate(startDate, type == 'week' ? 'd' : type, i),
			key = type == 'day' ? i + 1 : i,
			value =
				typeof dataSet?.[key] !== 'undefined' || dataSet?.[key] != null
					? dataSet[key].consumption
					: 0,
			cost = dataSet?.[key]?.cost,
			reversed =
				(typeof dataSet?.[key] !== 'undefined' || dataSet?.[key] != null) &&
				dataSet[key]?.reversed
					? -Math.abs(dataSet[key].reversed)
					: 0;
		if (type == 'week') {
			const day = dt.getDay();
			value /= days[day];
			cost /= days[day];
			reversed /= days[day];
		} else if (type == 'hour') {
			value /= periods.day;
			cost /= periods.day;
			reversed /= periods.day;
		}
		maxValue = Math.max(maxValue, value);
		if (maxValue == value || i == 0) {
			mostConsumingData = {
				index: key,
				consumption: value,
				cost,
				reversed,
			};
		}
		consumptionData.push({
			dt: dt.getTime(),
			value,
			reversed,
			convertCost: cost ? convertCost(cost, currency) : null,
		});
	}
	if (type == 'week' && !startsWeekOnSun()) {
		consumptionData.push(consumptionData.shift());
	}

	return {
		name: 'monthlyReport',
		type: type == 'week' ? 'area' : 'bar',
		units: 'Wh',
		//@ts-ignore
		rangePeriod: type == 'day' ? 'month' : type == 'week' ? 'day_of_week' : type,
		series: [
			{
				visible: true,
				name: 'consumption',
				data: consumptionData,
				style: 'monthly_report_consumption',
				stack: 'monthlyReport',
			},
			{
				visible: true,
				name: 'reversed',
				data: consumptionData.map((i) => (i = { dt: i.dt, value: i.reversed })),
				style: 'monthly_report_reversed',
				stack: 'monthlyReport',
			},
		],
		mostConsumingData,
		height: DEFAULT_CHART_HEIGHT,
	};
};
